import { render, staticRenderFns } from "./AxRiskLevel.vue?vue&type=template&id=095e0550&scoped=true&"
import script from "./AxRiskLevel.vue?vue&type=script&lang=js&"
export * from "./AxRiskLevel.vue?vue&type=script&lang=js&"
import style0 from "./AxRiskLevel.vue?vue&type=style&index=0&id=095e0550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095e0550",
  null
  
)

export default component.exports